import { ServiceTypes } from 'constants/ServiceTypes';
import { observer } from 'mobx-react-lite';
import React from 'react';
import Lottie, { Options } from 'react-lottie';
import { useInjection } from 'services/ioc/ioc.react';
import WizardStore from 'stores/WizardStore';
import step1 from '../PitchingProgress/images/animations/step1.json';
import step2 from '../PitchingProgress/images/animations/step2.json';
import step3 from '../PitchingProgress/images/animations/step3.json';
import { TextContainer, TextDiv, UnorderedList, WizardContentContainer } from './styles/WizardContentStyles';
import WizardSteps from './WizardSteps';

const WizardContent: React.FC = observer(() => {
  const wizardStore = useInjection<WizardStore>(ServiceTypes.WizardStore);

  const defaultOptions: Omit<Options, 'animationData'> = {
    loop: true,
    autoplay: true,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  const getImage = (): JSX.Element | null => {
    switch (wizardStore.currentStep) {
      case WizardSteps.Introduction:
        return <Lottie options={{ ...defaultOptions, animationData: step1 }} isClickToPauseDisabled={true} width={600} />;

      case WizardSteps.CleanHomeplate:
        return <Lottie options={{ ...defaultOptions, animationData: step2 }} isClickToPauseDisabled={true} width={600} />;

      case WizardSteps.CorrectPitching:
        return <Lottie options={{ ...defaultOptions, animationData: step3 }} isClickToPauseDisabled={true} width={600} />;

      default:
        return null;
    }
  };

  const getText = (): JSX.Element | null => {
    switch (wizardStore.currentStep) {
      case WizardSteps.Introduction:
        return (
          <TextContainer>
            <TextDiv paragraphGap='28px'>
              <div>This tool will capture data which will be sent to TrackMan for analysis and will result in a new calibration.</div>
              <div>Read the following steps for the best capture.</div>
            </TextDiv>
          </TextContainer>
        );
      case WizardSteps.CleanHomeplate:
        return (
          <TextContainer>
            <TextDiv paragraphGap='28px'>
              <div>
                Make sure that the <b>home plate is clean</b>, and free from dirt and other foreign material.
              </div>
            </TextDiv>
          </TextContainer>
        );
      case WizardSteps.CorrectPitching:
        return (
          <TextContainer>
            <TextDiv paragraphGap='12px'>
              <div>For a successful calibration:</div>
              <UnorderedList>
                <li>
                  At least <b>10 pitches</b> should land on the <b>home plate,</b> or at least <b>20 pitches</b> in the <b>landing area.</b>
                </li>
                <li>
                  Pitches should have a minimum velocity of <b>50 mph.</b>
                </li>
              </UnorderedList>
            </TextDiv>
          </TextContainer>
        );
      default:
        return null;
    }
  };

  return (
    <WizardContentContainer>
      {getImage()}
      {getText()}
    </WizardContentContainer>
  );
});

export default WizardContent;
